import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GetRoadmapOutputDto } from '../../../models/roadmap/dto/roadmap.dto';

export const GET_ROADMAP_QUERY_KEY = (organizationId: string) => [
    organizationId,
    'roadmap',
];

export const useGetRoadmap = (organizationId?: string) => {
    const client = useApiClient();

    return useQuery({
        enabled: Boolean(organizationId),
        queryKey: GET_ROADMAP_QUERY_KEY(organizationId ?? ''),
        queryFn: () =>
            client.fetchApi<GetRoadmapOutputDto, {}>({
                endpoint: `roadmap?organizationId=${encodeURIComponent(organizationId ?? '')}`,
                method: 'GET',
            }),
        // Keep it near-live so newly labelled issues show up quickly.
        staleTime: 30 * 1000,
    });
};
